module.exports = __webpack_public_path__ + "static/media/toniebox.1f3599da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/toniebox.png
// module id = 119
// module chunks = 0